export default function getAppVersionOrNull(): number | null {
  return process.env.AWS_JOB_ID != null ? parseInt(process.env.AWS_JOB_ID, 10) : null;
}
